<template>
    <div v-show="!isOpenSvg()">
        <template v-for="item in primitivesList">
            <component
                :is="item.component"
                :primitives="item.primitives"
                :fvSystemApi="item.fvSystemApi"
                :parentObject="item.parentObject"
                :key="item.registerName"
            ></component>
        </template>
    </div>
</template>
<style></style>
<script>
import Vue from 'vue';
import echarts from 'echarts';

Vue.prototype.$echarts = echarts;
import subUnit from '../../js/canvas/subUnit';
import divUnit from '../../js/div/divUnit';
import fvSystemApi from '../../js/fvSystemApi';

export default {
    name: 'fvGroupObj',
    props: ['primitives', 'fvSystemApi', 'parentObject'],
    created: function () {
        Object.assign(this, this.primitives);
        //打组需要加宽高，否则切掉一部分 所以二次计算 加10px
        this.height += this.height * this.frameScaleY + 10;
        this.width += this.width * this.frameScaleX + 10;

        this.domScale = this.parentObject.domScale;
        this.windowSize = this.parentObject.windowSize;
        this.defaultTailoring = this.parentObject.defaultTailoring ? this.parentObject.defaultTailoring : 20;
        this.modelsPath = this.parentObject.modelsPath.slice(0);

        this.modelsPath.push(this.registerName);
        //创建组内图元绘制的canvas内存
        this.$store.registerModule(this.modelsPath, {
            state: {
                $: this
            }
        });

        //此处保存了本模块的vuex对象，创建的子对象会加入到此，使前端脚本可以调用对象
        var tempObj = this.$store.state;
        for (var i = 0; i < this.modelsPath.length; i++) {
            tempObj = tempObj[this.modelsPath[i]];
        }
        this.subObjects = tempObj;

        if(this.isOpenSvg()) {
            this.foreign = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');//打组父级
            this.svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');//打组图元绘制区域
            this.foreign.appendChild(this.svgNode);
            this.parentObject.svgNode.appendChild(this.foreign);
            if(this.animation.fvLmousescript || this.animation.rmousedownscript || this.animation.fvContextMenu || this.animation.fvMessage || this.animation.fvMousescript || this.fctype == 'fvButtonObj') {
                this.theEvent(this.svgNode, this.primitives.animation, this.foreign);
            }
            //计算缩放比例
            this.heightTitle = 0;
            if(isApp()){
                var appTailoring = this.$store.state.system.$.appWinTitleHeight + this.$store.state.system.$.appWinSysHeight;
                this.scaleX = parseFloat(window.innerHeight - appTailoring) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleY = (parseFloat(window.innerWidth)-this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight)+this.heightTitle) ;
            }else{
                this.scaleX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
            }
            if(this.turn == "portrait" || this.turn == "transverse" || this.turn == "portraits" ){
                this.scaleX = 1;
                this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
            }
            if(this.$store.state.system.$.embedView == 1){
                if(innerHeight>innerWidth){
                    var rotate = 0;
                }else{
                    var rotate = 90;
                }
                if (rotate === 90) {
                    this.scaleX = parseFloat(window.innerWidth) / parseFloat(this.$store.state.system.$.screenWidth);
                    this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));
                } else {
                    this.scaleX = 1;
                    this.scaleY =( parseFloat(window.innerHeight)- this.heightTitle) / (parseFloat(this.$store.state.system.$.screenHeight));

                }
            }
            this.svgNode.style.width = '100%';
            this.svgNode.style.height = '100%';
            //判断是否是组内再打组
            this.foreign.setAttribute('x', this.x*this.scaleX);
            this.foreign.setAttribute('y', this.y*this.scaleY);

            this.foreign.style.width = this.width + 'px';
            this.foreign.style.height = this.height + 'px';
            this.svgNode.setAttribute('viewBox', `0 0 ${this.width} ${this.height}`);
        }
    },
    async mounted() {
        this.originalSize = {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            borderWidth: this.borderWidth
        };
        //svg 需要调用
        if(this.isOpenSvg()) {
            this.zoom();
        }
        this.isSub = this.parentObject.type == 'group';
        if(this.fcchildren) {
            var func = [];
            for (const element of this.fcchildren) {
                let i = this.fcchildren.indexOf(element);
                if(element == undefined || element == null) {
                    continue;
                }
                if(element.fctype.indexOf('Obj') < 0) {
                    element.x += element.x * this.frameScaleX;
                    element.y += element.y * this.frameScaleY;
                    element.height += element.height * this.frameScaleY;
                    element.width += element.width * this.frameScaleX;
                }
                // 特殊情况处理（恢复老工程多折线lineType设置为立体管道，多折线不存在立体管道类型，所以转为管道类型绘制图元）
                if((element.fctype === 'fvPolygonObj' || element.fctype === 'fvPolylineObj') && element.lineType === -1) {
                    element.fctype = 'fvPipeObj';
                    // 转义json线宽为0，暂时按照现场bug设置为3
                    element.borderWidth = 3;
                }
                if(this.isOpenSvg()) {
                  func.push(await new Promise((resolve, rejected) => {
                        try {
                            element.frameScaleX = this.frameScaleX;
                            element.frameScaleY = this.frameScaleY;
                            //draw边框导致所有图元需要按比例随访位置
                            if(Vue.component(element.fctype)) {
                                // element.parentXY = true;
                                element.x += element.x * element.frameScaleX;
                                element.y += element.y * element.frameScaleY;
                                element.height += element.height * element.frameScaleY;
                                element.width += element.width * element.frameScaleX;
                                this.primitivesList.push({
                                    component: element.fctype,
                                    primitives: element,
                                    registerName: element.registerName,
                                    parentObject: this,
                                    fvSystemApi: this.fvSystemApi
                                });
                                resolve();
                            } else {
                                //需要使用配置来判断是否是div还是canvas
                                this.openViewName = 'windowComponentDiv';
                                this.parentX = this.x;
                                this.parentY = this.y;
                                new divUnit[element.fctype](element, this, this.svgNode, obj => {
                                    obj.isSub = true;
                                    this.subObjects[obj.name] = {
                                        $: obj
                                    };
                                    this.zIndexObjList.push({
                                        name: obj.name,
                                        zIndex: obj.zIndex
                                    });
                                    resolve();
                                });
                                
                            }
                        } catch (e) {
                            console.log('此类型不存在：%c' + element.fctype, 'color:#f00;');
                            console.log(e);
                            resolve();
                        }
                    })
                  );
                }else{
                  func.push(new Promise((resolve, rejected) => {
                        try {
                            element.frameScaleX = this.frameScaleX;
                            element.frameScaleY = this.frameScaleY;
                            //draw边框导致所有图元需要按比例随访位置
                            if(Vue.component(element.fctype)) {
                                this.primitivesList.push({
                                    component: element.fctype,
                                    primitives: element,
                                    registerName: element.registerName,
                                    parentObject: this,
                                    fvSystemApi: this.fvSystemApi
                                });
                                resolve();
                            } else {
                                //需要使用配置来判断是否是div还是canvas
                                this.openViewName = 'windowComponent';
                                new subUnit[element.fctype](element, this, this.$store.state.system, obj => {
                                    obj.isSub = true;
                                    this.subObjects[obj.name] = {
                                        $: obj
                                    };
                                    this.zIndexObjList.push({
                                        name: obj.name,
                                        zIndex: obj.zIndex
                                    });
                                    resolve();
                                });
                            }
                        } catch (e) {
                            console.log('此类型不存在：%c' + element.fctype, 'color:#f00;');
                            console.log(e);
                            resolve();
                        }
                    })
                  );
                }  
            }
            Promise.all(func).then(() => {
              var parent = this.$store.state;
              for (var i = 0; i < this.modelsPath.length; i++) {
                  parent = parent[this.modelsPath[i]];
              }
              this.fcchildren.forEach((element, i) => {
                  if(element == undefined || element == null) {
                      return;
                  }
                  if(Vue.component(element.fctype)) {
                      this.primitivesList.forEach(e => {
                          if(element.registerName == e.registerName) {
                              this.subObjects[element.registerName] = parent[e.registerName];
                              this.zIndexObjList.push({
                                  name: element.registerName,
                                  zIndex: element.zIndex
                              });
                          }
                      });
                  }
              });
              this.zIndexObjList.sort(function (obj1, obj2) {
                  return obj1.zIndex - obj2.zIndex;
              });
              this.onSuccess();
            });
        }
    },

    data: function () {
        return {
            windowSize: {},
            width: 0,
            height: 0,
            primitivesList: [],
            modelsPath: [],
            zIndexObjList: [],
            subObjects: {},
            isOpenSuccess: false,
            type: 'group',
            isEnable: true,
            fcHide: true,
            isSub: false,
            preAnimation: {},
            posAimation: {},
            domScale: {
                zoom: 0,
                x: this.parentObject.y,
                y: this.parentObject.x,
                sx: 1,
                sy: 1,
                ox: 0,
                oy: 0,
                scrollHeight: 0,
                scrollWidth: 0,
                titleHeight: 0
            }
        };
    },

    methods: {
        //判断是否是 启用svg
        isOpenSvg() {
            if(this.$store.state.system.$.indexDB == null) {
                return false;
            } else {
                if(this.$store.state.system.$.indexDB[0].isSvg) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        //打组点击事件
        theEvent(div, sContent, foreign) {
            if(sContent.fvLmousescript) {
                div.style.cursor = 'pointer';
            }
            //鼠标按下
            div.onmousedown = function (e) {
                this.onMouseDownSvg(e, div, foreign, this);
            }.bind(this);
            //鼠标抬起
            div.onmouseup = function (e) {
                this.onMouseUpSvg(e, div, foreign);
            }.bind(this);
            //鼠标移入
            div.onmouseenter = function (e) {
                this.onMouseEnterSvg(e, div, foreign);
            }.bind(this);
            //鼠标移出
            div.onmouseleave = function (e) {
                this.onMouseLeaveSvg(e, div, foreign);
            }.bind(this);
            //鼠标移动
            div.onmousemove = function (e) {
                this.onMouseMoveSvg(e, div, foreign);
            }.bind(this);

        },
        getMagnification() {
            return this.parentObject.getMagnification();
        },
        updataSize(subObjSize) {
            // if (this.subObjBorder < subObjSize.borderWidth) {
            //     this.subObjBorder = subObjSize.borderWidth;
            // }
            // this.x -= this.subObjBorder / 2;
            // this.width += this.subObjBorder / 2;

            // this.y -= this.subObjBorder / 2;
            // this.height += this.subObjBorder / 2;
        },
        zoom() {

            var value = 0;
            //暂不需要打组后计算偏差的代码
            if(this.isOpenSvg()) {
                var value = 5;//打组后 添加边框会被截取
            }
            var magnification = this.parentObject.getMagnification();
            this.x = this.originalSize.x * magnification.x - value;
            this.y = this.originalSize.y * magnification.y - value;
            this.width = this.originalSize.width * magnification.x + value;
            this.height = this.originalSize.height * magnification.y + value;
            this.borderWidth = this.originalSize.borderWidth * magnification.x;
        },
        /*
                参数：无
                作用：窗口加载完成
            */
        onSuccess() {
            this.zoom();
            this.init();
            this.VueSub = this.$store.state;
            for (var i = 0; i < this.modelsPath.length; i++) {
                this.VueSub = this.VueSub[this.modelsPath[i]];
            }
            this.fcchildren.forEach((element, i) => {
                if(element == undefined || element == null) {
                    return;
                }
                if(Vue.component(element.fctype)) {
                    this.primitivesList.forEach(e => {
                        this.subObjects[e.registerName] = this.VueSub[e.registerName];
                    });
                }
            });

            //执行初次进入脚本
            this.fvScript.executionScript(this.entrancescript);
            this.isOpenSuccess = true;
        },

        init() {
            this.regionHeight = this.height - 2 * this.borderWidth;
            this.regionWidth = this.width - 2 * this.borderWidth;
            //前后置动画列表
            this.preAnimationList = {};
            this.mouseAnimationList = {};
            this.posAnimation = {};
            for (var property in this.animation) {
                if(this.isOpenSvg()) {
                    property = property + 'Svg';
                    var ani = new Vue.prototype[property](this);
                    switch (ani.type) {
                        case 'fvContextMenu':
                        case 'fvMessage':
                        case 'fvVarInput':
                        case 'fvBoolInput':
                        case 'fvStringInput':
                        case 'fvVerticalDrag':
                        case 'fvHorDrag':
                        case 'fvLmousescript':
                        case 'fvRmousescript':
                        case 'fvMousescript':
                        case 'fvWindowOpen':
                        case 'fvContextMenuSvg':
                        case 'fvMessageSvg':
                        case 'fvVarInputSvg':
                        case 'fvBoolInputSvg':
                        case 'fvStringInputSvg':
                        case 'fvVerticalDragSvg':
                        case 'fvHorDragSvg':
                        case 'fvLmousescriptSvg':
                        case 'fvRmousescriptSvg':
                        case 'fvMousescriptSvg':
                        case 'fvWindowOpenSvg':
                            this.mouseAnimationList[ani.type] = ani;
                            break;
                        case 'fvFlow':
                        case 'fvHorFill':
                        case 'fvRotateMove':
                        case 'fvVerticalFill':
                            this.preAnimation[ani.type] = ani;
                            this.posAnimation[ani.type] = ani;
                            break;
                        case 'fvHide':
                        case 'fvForbid':
                        case 'fvTwinkel':
                        case 'fvVerticalMove':
                        case 'fvHorMove':
                            this.posAnimation[ani.type] = ani;
                            this.preAnimation[ani.type] = ani;
                            break;
                        default:
                            this.preAnimation[ani.type] = ani;
                            break;
                    }
                } else {
                    var ani = new Vue.prototype[property](this);
                    switch (ani.type) {
                        case 'fvContextMenu':
                        case 'fvMessage':
                        case 'fvVarInput':
                        case 'fvBoolInput':
                        case 'fvStringInput':
                        case 'fvVerticalDrag':
                        case 'fvHorDrag':
                        case 'fvLmousescript':
                        case 'fvRmousescript':
                        case 'fvMousescript':
                        case 'fvWindowOpen':
                            this.mouseAnimationList[ani.type] = ani;
                            break;
                        case 'fvFlow':
                        case 'fvHorFill':
                        case 'fvRotateMove':
                        case 'fvVerticalFill':
                            this.preAnimation[ani.type] = ani;
                            this.posAnimation[ani.type] = ani;
                            break;
                        case 'fvHide':
                        case 'fvForbid':
                        case 'fvTwinkel':
                        case 'fvVerticalMove':
                        case 'fvHorMove':
                            this.preAnimation[ani.type] = ani;
                            break;
                        default:
                            this.preAnimation[ani.type] = ani;
                            break;
                    }
                }
            }
        },

        formatRect() {
            var magnification = this.parentObject.getMagnification();
            this.x = this.originalSize.x * magnification.x;
            this.y = this.originalSize.y * magnification.y;
        },
        createStyle(canvas, show) {
            //判断是否是组内再打组
            if(show) {
                this.foreign.setAttribute('x', this.x - this.parentObject.parentX);
                this.foreign.setAttribute('y', this.y - this.parentObject.parentY);
                if(this.parentX == undefined) {this.parentX = this.x;}
                if(this.parentY == undefined) {this.parentY = this.y;}
                this.svgNode.setAttribute('viewBox', `${this.x - this.parentX} ${this.y - this.parentY} ${this.width} ${this.height}`);


            } else {
                this.foreign.setAttribute('x', this.x);
                this.foreign.setAttribute('y', this.y);
                this.svgNode.setAttribute('viewBox', `${this.x - this.parentX} ${this.y - this.parentY} ${this.width} ${this.height}`);
            }
            this.foreign.style.width = this.width + 'px';
            this.foreign.style.height = this.height + 'px';

            for (var k in this.subObjects) {
                try {
                    if(k == '$') {
                        continue;
                    }
                    if(this.subObjects[k].$.onDraw) {
                        if(!this.subObjects[k].$.display || this.subObjects[k].$.display == 'block') {
                            //判断是否是svg
                            this.subObjects[k].$.createStyle(canvas, true);
                        }
                    }
                } catch (error) {
                    console.log('**********' + k + 'cache 执行错误**********');
                    console.log(error);
                }
            }
        },
        onDraw(canvas) {
            if(!this.isOpenSvg()) {
                this.executePosAnimation(canvas);
            }
            for (var i = 0; i < this.zIndexObjList.length; i++) {
                var obj = this.zIndexObjList[i];
                try {
                    if(obj.name == '$') {
                        continue;
                    }
                    if(this.subObjects[obj.name].$.onDraw) {
                        if(!this.subObjects[obj.name].$.display || this.subObjects[obj.name].$.display == 'block') {
                            //判断是否是svg
                            if(this.isOpenSvg()) {
                                this.subObjects[obj.name].$.onDraw(canvas);
                            } else {
                                canvas.save();
                                this.subObjects[obj.name].$.onDraw(canvas);
                                canvas.restore();
                            }
                        }
                    }
                } catch (error) {
                    console.log('**********' + obj.name + 'cache 执行错误**********');
                    console.log(error);
                }
            }
            this.executeDrawAnimation(canvas);
        },

        reDraw(scaleObj) {
            this.zoom();
            for (var p in this.subObjects) {
                try {
                    if(p == '$') {
                        continue;
                    }
                    if(this.subObjects[p].$.reDraw) {
                        //属性display不存在或者不为block时，图元隐藏，不去绘制
                        if(!this.subObjects[p].$.display || this.subObjects[p].$.display == 'block') {
                            this.subObjects[p].$.reDraw(scaleObj);
                        }
                    }
                } catch (error) {
                    console.log('**********' + p + ' reDraw函数**********');
                    console.log(error);
                }
            }
        },
        doFixEvent(e, type, doFixEventOnMouseUp) {
            var style = 'default';
            this.domScale = this.parentObject.domScale;
            for (var p in this.subObjects) {
                if(p == '$') continue;
                if(this.subObjects[p].$.type == 'basic') {
                    this.subObjects[p].$[type](e, this.domScale, doFixEventOnMouseUp);
                    if(type == 'onMouseMove' && this.subObjects[p].$.isHasAnimation(['fvLmousescript', 'fvRmousescript', 'fvMousescript']) && this.subObjects[p].$.mouseState) {
                        if(style == 'default') {
                            style = 'pointer';
                        }
                    }
                } else if(this.subObjects[p].$.doFixEvent) {
                    var subStyle = this.subObjects[p].$.doFixEvent(e, type, doFixEventOnMouseUp);
                    if(style == 'default') {
                        style = subStyle;
                    }
                }
            }
            return style;
        },

        onTimer(time) {
            if(this.isOpenSuccess == false) return;
            //执行周期执行脚本
            var currTime = new Date().getTime();
            if(currTime - this.lastTime > this.timer) {
                this.fvScript.executionScript(this.timerscript);
                this.lastTime = currTime;
            }
            //调用各自对象的周期函数
            for (var p in this.subObjects) {
                if(p != '$') {
                    this.subObjects[p].$.onTimer(time, true);
                }
            }
        },

        setFcHide(hideFlag) {
            for (var p in this.subObjects) {
                this.subObjects[p].$.setFcHide(hideFlag);
            }
        },

        onUpdata() {
            for (var p in this.subObjects) {
                if(p == '$') {
                    continue;
                }
                if(this.subObjects[p].$.onUpdata) {
                    this.subObjects[p].$.onUpdata();
                }
            }
        },

        runAnimation(event, canvas, mouseAnimType, show, obj) {
            if(this.isOpenSvg()) {
                //要处理禁止动作//
                if(mouseAnimType == 'fvForbid') {
                    this.mouseAnimationList[fvForbid].run(event);
                }
                if(this.mouseAnimationList[mouseAnimType]) {
                    this.mouseAnimationList[mouseAnimType].run(event, show, canvas, obj);
                }
            } else {
                //要处理禁止动作//
                if(this.mouseState) {
                    if(this.disableFlag) {
                        return;
                    }
                }
                if(this.mouseAnimationList[mouseAnimType]) {
                    this.mouseAnimationList[mouseAnimType].run(event, canvas);
                }
            }

        },
        /*
            功能:鼠标按下
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseDownSvg(e, domObj) {
            this.isMouseMove = true;
            if(e.touches) {
                this.runAnimation(e, domObj.ctx, 'fvLmousescript');
                this.runAnimation(e, domObj, 'fvVarInput');
                this.runAnimation(e, domObj, 'fvBoolInput');
                this.runAnimation(e, tdomObj, 'fvStringInput');
                //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
                this.runAnimation(e, tdomObj, 'fvHorDrag');
                this.runAnimation(e, tdomObj, 'fvWindowOpen');
            } else {
                switch (e.button) {
                    case 0://鼠标左键按下
                        this.runAnimation(e, domObj, 'fvLmousescript');
                        this.runAnimation(e, domObj, 'fvVarInput');
                        this.runAnimation(e, domObj, 'fvBoolInput');
                        this.runAnimation(e, domObj, 'fvStringInput');
                        //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
                        this.runAnimation(e, domObj, 'fvHorDrag');
                        this.runAnimation(e, domObj, 'fvWindowOpen');
                        //用于动画与点击同步执行
                        setTimeout(() => {
                            for (var p in this.preAnimationList) {
                                //判断是否是 流动
                                if(p != 'fvFlow') {
                                    this.preAnimationList[p].run(domObj);
                                }
                            }
                        }, 300);
                        break;
                    case 1:
                        //this.runAnimation(e,this.parent.ctx,MOUSEANIMTYPE_RMOUSE);
                        break;
                    case 2:
                        this.runAnimation(e, domObj, 'fvRmousescript');
                        this.runAnimation(e, domObj, 'fvContextMenu');
                        break;
                    default:
                        break;
                }
            }
        },

        /*
            功能:鼠标弹起
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseUpSvg(e, domObj) {
            this.isMouseMove = false;
            if(e.touches) {
                this.runAnimation(e, domObj, 'fvLmousescript', 0);
                //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
            } else {
                switch (e.button) {
                    case 0://鼠标左键抬起
                        this.runAnimation(e, domObj, 'fvLmousescript');
                        //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
                        break;
                    case 1:
                        break;
                    case 2:
                        this.runAnimation(e, domObj, 'fvRmousescript');
                        break;
                    default:
                        break;
                }
            }

            // //鼠标在图元外抬起时
            // this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
            // this.runAnimation(e,this.parent.ctx,"fvHorDrag");
        },
        /*
            功能:鼠标移动
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseMoveSvg(e, domObj, foreign, obj) {
            if(this.isMouseMove == true) {
                //打组鼠标位置是组内位置并非全局位置
                var eve = {
                    offsetY: e.offsetY + this.y,
                    offsetX: e.offsetX + this.x
                };
                //拖动动画
                this.runAnimation(eve, foreign, 'fvVerticalDrag');//垂直
                this.runAnimation(eve, foreign, 'fvHorDrag');//水平
            }
            this.runAnimation(e, domObj, 'fvMessage', true);
            this.runAnimation(e, domObj, 'fvMousescript', '移动');
        },
        /*
            功能:鼠标进入
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseEnterSvg(e, domObj) {
            //this.runAnimation(e,this.parent.ctx,"fvVerticalDrag");
            //this.runAnimation(e,this.parent.ctx,"fvHorDrag");
            this.runAnimation(e, domObj, 'fvMessage', true);
            this.runAnimation(e, domObj, 'fvMousescript', '进入');

        },
        /*
            功能:鼠标离开
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseLeaveSvg(e, domObj) {
            this.isMouseMove = false;
            this.runAnimation(e, domObj, 'fvMessage', false);
            this.runAnimation(e, domObj, 'fvMousescript', '离开');
        },

        //按下
        onMouseDown(e, scaleObj) {
            this.mouseState = this.doFixedEvent(e, scaleObj);
            if(this.mouseState) {
                if(e.touches) {
                    this.runAnimation(e, this.parentObject.ctx, 'fvLmousescript');
                    this.runAnimation(e, this.parentObject.ctx, 'fvVarInput');
                    this.runAnimation(e, this.parentObject.ctx, 'fvBoolInput');
                    this.runAnimation(e, this.parentObject.ctx, 'fvStringInput');
                    this.runAnimation(e, this.parentObject.ctx, 'fvVerticalDrag');
                    this.runAnimation(e, this.parentObject.ctx, 'fvHorDrag');
                    this.runAnimation(e, this.parentObject.ctx, 'fvWindowOpen');
                } else {
                    switch (e.button) {
                        case 0: //鼠标左键按下
                            this.runAnimation(e, this.parentObject.ctx, 'fvLmousescript');
                            this.runAnimation(e, this.parentObject.ctx, 'fvVarInput');
                            this.runAnimation(e, this.parentObject.ctx, 'fvBoolInput');
                            this.runAnimation(e, this.parentObject.ctx, 'fvStringInput');
                            this.runAnimation(e, this.parentObject.ctx, 'fvVerticalDrag');
                            this.runAnimation(e, this.parentObject.ctx, 'fvHorDrag');
                            this.runAnimation(e, this.parentObject.ctx, 'fvWindowOpen');
                            break;
                        case 1:
                            //this.runAnimation(e,this.parentObject.ctx,MOUSEANIMTYPE_RMOUSE);
                            break;
                        case 2:
                            this.runAnimation(e, this.parentObject.ctx, 'fvRmousescript');
                            this.runAnimation(e, this.parentObject.ctx, 'fvContextMenu');
                            break;
                        default:
                            break;
                    }
                }
            }
        },

        //弹起
        onMouseUp(e, scaleObj) {
            this.mouseState = this.doFixedEvent(e, scaleObj);
            if(this.mouseState) {
                if(e.touches) {
                    this.runAnimation(e, this.parentObject.ctx, 'fvLmousescript', 0);
                    this.runAnimation(e, this.parentObject.ctx, 'fvVerticalDrag');
                } else {
                    switch (e.button) {
                        case 0: //鼠标左键抬起
                            this.runAnimation(e, this.parentObject.ctx, 'fvLmousescript');
                            this.runAnimation(e, this.parentObject.ctx, 'fvVerticalDrag');
                            break;
                        case 1:
                            break;
                        case 2:
                            this.runAnimation(e, this.parentObject.ctx, 'fvRmousescript');
                            break;
                        default:
                            break;
                    }
                }
            }
            //鼠标在图元外抬起时
            this.runAnimation(e, this.parentObject.ctx, 'fvVerticalDrag');
            this.runAnimation(e, this.parentObject.ctx, 'fvHorDrag');
        },
        //移动
        onMouseMove(e, scaleObj) {
            this.mouseState = this.doFixedEvent(e, scaleObj);
            if(this.mouseState) {
                this.runAnimation(e, this.parentObject.ctx, 'fvVerticalDrag');
                this.runAnimation(e, this.parentObject.ctx, 'fvHorDrag');
            }

            this.runAnimation(e, this.parentObject.ctx, 'fvMessage');
            this.runAnimation(e, this.parentObject.ctx, 'fvMousescript');
        },
        /*
            功能:鼠标进入
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseEnter(e, scaleObj) {
            this.mouseState = this.doFixedEvent(e, scaleObj);
            if(this.mouseState) {
                this.runAnimation(e, this.parentObject.ctx, 'fvVerticalDrag');
                this.runAnimation(e, this.parentObject.ctx, 'fvHorDrag');
                this.runAnimation(e, this.parentObject.ctx, 'fvMessage');
                this.runAnimation(e, this.parentObject.ctx, 'fvMousescript');
            }
        },
        /*
            功能:鼠标离开
            参数:e 属性信息 scaleObj 缩放信息
            返回值:无
        */
        onMouseLeave(e, scaleObj) {
            this.mouseState = false;
            this.runAnimation(e, this.parentObject.ctx, 'fvMessage');
            this.runAnimation(e, this.parentObject.ctx, 'fvMousescript');
        },

        doFixedEvent(event, scaleObj) {
            //判断前设置默认没有进入图形，防止隐藏或禁用图形是捕捉不到离开事件
            if(!this.isEnable || !this.fcHide) {
                //图元隐藏、禁用时不响应事件
                return null;
            }
            // var eventX = this.mouseX(event);
            // var eventY = this.mouseY(event);
            var eventX = event.clientX + this.$el.parentNode.scrollLeft;
            var eventY = event.clientY + this.$el.parentNode.scrollTop;
            if(isApp()){
                var eventX = event.clientX + this.$el.parentNode.parentNode.parentNode.parentNode.parentNode.scrollLeft;
                var eventY = event.clientY + this.$el.parentNode.parentNode.parentNode.parentNode.parentNode.scrollTop;
            }
            var leftX = parseInt(scaleObj.ox + this.originalSize.x * (scaleObj.sx + scaleObj.zoom) + scaleObj.x - scaleObj.scrollWidth);
            var rightX = parseInt(this.originalSize.width * (scaleObj.sx + scaleObj.zoom) + leftX);
            var topY = parseInt(scaleObj.oy + this.originalSize.y * (scaleObj.sy + scaleObj.zoom)) + scaleObj.y + scaleObj.titleHeight - scaleObj.scrollHeight;
            var bottomY = parseInt(this.originalSize.height * (scaleObj.sy + scaleObj.zoom) + topY);
            if(eventX < rightX && eventX > leftX && eventY < bottomY && eventY > topY) {
                return true;
            } else {
                return false;
            }
        },

        //获取事件绝对位置
        mouseX(evt) {
            if(evt.pageX) return evt.pageX;
            else if(evt.clientX) return evt.clientX + (document.documentElement.scrollLeft ? document.documentElement.scrollLeft : document.body.scrollLeft);
            else return null;
        },

        mouseY(evt) {
            if(evt.pageY) return evt.pageY;
            else if(evt.clientY) return evt.clientY + (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop);
            else return null;
        },
        //图形绘制前执行
        executePreAnimation(canvas) {
            if(this.isOpenSvg()) {
                this.canvas = canvas;
                // 打组禁止
                if(this.disableFlag) {
                    return;
                }
                // 当前图元禁止
                if(!this.fcHide) {
                    for (const property in this.animation) {
                        if(new Vue.prototype[property](this).type == 'fvTwinkel') {
                            for (var a in this.preAnimationList) {
                                this.preAnimationList[a].run(this.canvas, this.isEnable);
                            }
                        } else {
                            return;
                        }
                    }
                }
                if(this.canvas) {
                    for (var p in this.preAnimationList) {
                        this.preAnimationList[p].run(canvas, this.isEnable);
                    }
                }
            } else {
                if(!this.isEnable) {
                    return;
                }
                for (var p in this.preAnimationList) {
                    this.preAnimationList[p].run();
                }
            }
        },
        //图形绘制后执行
        executePosAnimation(canvas) {
            if(!this.isEnable) {
                return;
            }
            for (var p in this.preAnimation) {
                this.preAnimation[p].run(canvas);
            }
        },
        //图形绘制到canvas上以后执行（当前只有旋转动画）
        executeDrawAnimation(canvas) {
            if(!this.isEnable) {
                return;
            }
            for (var p in this.posAnimation) {
                if(this.posAnimation[p].runEnd){
                    this.posAnimation[p].runEnd(canvas)
                }else{
                    this.posAnimation[p].run(canvas);
                }
            }
        },
        //允许或禁止对图形对象。
        Enable(state) {
            //isEnable:false 禁止；true：不禁止
            this.isEnable = state ? true : false;
            this.disableFlag = state ? false : true;
            // 调用各自对象的周期函数
            for (var p in this.subObjects) {
                if(p != '$') {
                    this.subObjects[p].$.Enable(state);
                }
            }
        },
        //显示或隐藏图形目标
        Show(flag) {
            //fcHide:false 隐藏；true：不隐藏
            this.fcHide = flag ? true : false;
            for (var p in this.subObjects) {
                if(p != '$') {
                    this.subObjects[p].$.Show(flag);
                }
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/system/fvGroupObj.vue